import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { typeOptions } from '../../../utils/type/dynamic-rendering.interfaces';
import { setValueMultipleOptions, setValueOptions } from '../../../store/actions/setting';
import { getValueMultipleOption, getValueOption, valueMultipleOption, valueOption } from '../../../store/selectors/selectors';
//@ts-ignore
import s from './PorchSides.module.scss'
//@ts-ignore
import { getUrlImg } from '../../../utils/utilsFunctions';



// [key: string]: unknown;
type sideT = {
    icon: string
    iconActive: string
    id: string
    name: string
}

type PorchSidesT = {
    children: any
    id: string
    text: string
    typeOptions: typeOptions
    values: sideT[]
}


export const PorchSides = ({ ...props }: PorchSidesT) => {

    const { values, text, id } = props;
    const dispatch = useDispatch();

    let { selectValue, isError }: valueMultipleOption = useSelector(state => getValueMultipleOption(id)(state));
    const onChange = (value: sideT) => {
        dispatch(setValueMultipleOptions({ idParams: id, valueParam: value['id'] }))
    }

    return (
        <div className={s.wrap}>
            <div className={s.text}>{text}</div>
            <div className={s.porchWrap}>
                {
                    values.map((value: sideT) => {

                        let isActive = !!selectValue && selectValue.includes(value['id'])

                        let classItem = `${s.porchItem}`
                        if (isActive) classItem += ` ${s.active}`

                        return (<>
                            <div className={`${classItem}`} onClick={() => onChange(value)}>
                                <div className={s.icon}>
                                    {isActive ? (
                                        <img src={`${getUrlImg(value['iconActive'])}`} alt="" />

                                    ) : (
                                        <img src={`${getUrlImg(value['icon'])}`} alt="" />

                                    )}
                                </div>
                                <div className={s.porchName}>{value['name']}</div>
                            </div>
                        </>)
                    })
                }


            </div>
        </div>
    )
}
